import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import https from 'https'
import axios from 'axios'

import constList from '@/store/modules/ConstList'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'

import VueClipboard from 'vue-clipboard2'

import { ValidationProvider, ValidationObserver, localize, extend } from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja.json'
import * as rules from 'vee-validate/dist/rules'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.use(VueClipboard)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
localize('ja', ja)
Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule])
})

axios.interceptors.request.use((request) => {
  // Axios経由のHTTPS接続で証明書エラーが出るので暫定対応
  request.httpsAgent = new https.Agent({ rejectUnauthorised: false })
  return request
})

axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(new Error('canceled'))
    } else {
      const { status } = error.response
      // 認証が出来ていない場合はログイン画面に遷移する
      if (status === 401) {
        store.dispatch('auth/logout')
      }
      return Promise.reject(error)
    }
  }
)

Vue.prototype.$axios = axios
Vue.prototype.$constList = constList

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')

// 同時ログイン制限
window.addEventListener('storage', function (event) {
  if (typeof window._debounceStorageEvent !== 'undefined') {
    clearTimeout(window._debounceStorageEvent)
  }
  // eslint-disable-next-line no-new
  new Promise((resolve) => {
    window._debounceStorageEvent = setTimeout(async () => {
      if (store.getters['auth/isLoggedIn'] && event.key === 'logout') {
        await store.dispatch('auth/logout')
        alert('他のタブやウインドウでログアウト操作があったためログアウトしました')
      }
    }, 400)
  })
})
